<template>
  <v-card>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title>Edit Bill</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field label="Registered Company to Bill" v-model="bill.registered_company_to_bill" />
          </v-flex>
          <v-flex xs12 sm6>
            <v-select :items="typesOfFee" v-model="bill.type_of_fee" label="Type of Fee"></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <select-bill-type :billId="null" :billType="bill.type" :label="'Bill Type'" @changed="childTypeChanged" />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="Drawdown amount" v-model="bill.drawdown"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="Fee" v-model="bill.fee"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <bill-date-picker
              :billDate="bill.bill_date"
              :billId="null"
              :dateColumn="'bill_date'"
              :label="'Bill Date'"
              @changed="childDateChanged"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <bill-date-picker
              :billDate="bill.received_date"
              :billId="null"
              :dateColumn="'received_date'"
              :label="'Date Received/Paid'"
              @changed="childDateChanged"
            />
          </v-flex>
          <v-flex xs12>
            <v-textarea label="Comments" v-model="bill.comments"></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="close" :disabled="isSaving">Close</v-btn>
      <v-btn color="accent" @click="update" :loading="isSaving">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import _ from 'lodash';
import SelectBillType from '../Widgets/SelectBillType';
import BillDatePicker from '../Widgets/BillDatePicker';
import moment from 'moment';

export default {
  name: 'edit-bill-form',
  components: {
    SelectBillType,
    BillDatePicker
  },
  props: ['dialog', 'billDetails'],
  data: () => ({
    isSaving: false,
    bill: {
      id: null,
      enquiry_id: null,
      registered_company_to_bill: null,
      type_of_fee: null,
      type: '',
      fee: 0,
      drawdown: 0,
      bill_date: moment().format('YYYY-MM-DD HH:mm:ss'),
      received_date: null,
      comments: null
    },
    typesOfFee: ['Initial Fee', 'Ongoing Facility Fee']
  }),
  computed: {
    isBilled() {
      return this.billDetails.bill_date !== null;
    }
  },
  methods: {
    ...mapActions(['updateBill', 'addNotification']),
    childTypeChanged(type) {
      this.bill.type = type;
    },
    childDateChanged(date, column) {
      this.bill[column] = date;
    },
    childReferralDateChanged(date) {
      this.referral_credit.bill_date = date;
    },
    close() {
      this.$emit('updated', false);
    },
    async update() {
      this.isSaving = true;

      try {
        await this.updateBill({
          id: this.bill.id,
          updates: this.bill
        });
        this.addNotification({
          text: `Bill updated`
        });
      } catch (error) {
        this.addNotification({
          text: `BILL NOT UPDATED: ${error.response.data.Error}`
        });
      }

      this.$emit('updated', true);
      this.isSaving = false;
    },
    setVariables: function(billDetails) {
      this.bill = {
        id: billDetails.id,
        enquiry_id: billDetails.enquiry_id,
        registered_company_to_bill: billDetails.registered_company_to_bill,
        type_of_fee: billDetails.type_of_fee,
        type: billDetails.type,
        fee: billDetails.fee,
        drawdown: billDetails.drawdown,
        bill_date: billDetails.bill_date ? moment(billDetails.bill_date).format('YYYY-MM-DD HH:mm:ss') : null,
        received_date: _.isNull(billDetails.received_date)
          ? null
          : moment(billDetails.received_date).format('YYYY-MM-DD HH:mm:ss'),
        comments: billDetails.comments || null
      };
    }
  },
  mounted() {
    if (!_.isUndefined(this.billDetails.id)) {
      this.setVariables(this.billDetails);
    }
  },
  watch: {
    billDetails: function(billDetails) {
      this.setVariables(billDetails);
    }
  }
};
</script>

<style scoped></style>
